import { useEffect } from 'react';

import { startVersionPolling } from '../utils/versionCheck';

/**
 * Component that polls for new app versions and prompts users to refresh
 * Prevents chunk loading errors during deployments
 */
export function VersionChecker() {
  useEffect(() => {
    // Start checking for new versions every 5 minutes
    const cleanup = startVersionPolling(5 * 60 * 1000);

    // Cleanup when component unmounts
    return cleanup;
  }, []);

  // This component doesn't render anything
  return null;
}
